module.exports = __webpack_public_path__ + "img/3_Left.bcaf626a.png";